import { render, staticRenderFns } from "./WPBreadcrumbs.vue?vue&type=template&id=6e36307a"
import script from "./WPBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./WPBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./WPBreadcrumbs.vue?vue&type=style&index=0&id=6e36307a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports